<template>
  <div :style="logoStyle"></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  computed: {
    logoStyle: function() {
      let logoConfig = JSON.parse(this.$supMainPageConfig).logo.imgUrl;
      return {
        backgroundImage: "url(" + logoConfig + ")",
        backgroundRepeat: "round",
        height: "41px",
        width: "124px"
      };
    }
  }
};
</script>

<style scoped lang="scss">
</style>
